import type { EmotionCache } from '@emotion/react';
import { CacheProvider } from '@emotion/react';
import '../packages/editor/index.css';
import '../packages/editor/index2.css';
import '../styles/styles.css';
// import plugin css. We recommend to do that
// where you import the plugin itself,
// but there is a problem currently preventing us from do so,
// but that only applies to this example project
// see https://github.com/vercel/next.js/issues/19717
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';

import 'katex/dist/katex.min.css';
import type { AppProps } from 'next/app';
import { Toaster } from 'react-hot-toast';
import createEmotionCache from '../utils/createEmotionCache';
import './globals.css';
import './styles.css';

const clientSideEmotionCache = createEmotionCache();
const theme = createTheme();
function MyApp({
  Component,
  pageProps,
  emotionCache = clientSideEmotionCache,
}: AppProps & { emotionCache: EmotionCache }) {
  return (
    <CacheProvider value={emotionCache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Toaster />
        <Component {...pageProps} />
      </ThemeProvider>
    </CacheProvider>
  );
}

export default MyApp;
